<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

defineOptions({
  inheritAttrs: false,
})

interface Props {
  class?: HTMLAttributes['class']
  title?: string
  description?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: 'No messages yet',
  description: 'Start a conversation to see messages here',
})
</script>

<template>
  <div
    :class="
      cn(
        'flex size-full flex-col items-center justify-center gap-3 p-8 text-center',
        props.class
      )
    "
    v-bind="$attrs"
  >
    <slot>
      <div v-if="$slots.icon" class="text-gray-500 dark:text-gray-400">
        <slot name="icon" />
      </div>

      <div class="space-y-1">
        <h3 class="text-sm font-medium text-gray-900 dark:text-gray-100">
          {{ props.title }}
        </h3>
        <p
          v-if="props.description"
          class="text-sm text-gray-500 dark:text-gray-400"
        >
          {{ props.description }}
        </p>
      </div>
    </slot>
  </div>
</template>
